import { CheckboxStyled } from 'src/common/components/CheckboxStyled/CheckboxStyled';
import { useExternalRowSelectionApi } from './hooks/useExternalRowSelectionApi';

export const ExternalRowSelectionCheckbox = <T extends { id: string }>({ id }: T) => {
  const { selectedIds, toggleRow } = useExternalRowSelectionApi();

  return (
    <CheckboxStyled
      isChecked={selectedIds.has(id)}
      onChange={() => toggleRow(id)}
      slotProps={{
        input: {
          'aria-label': 'Select row',
        },
      }}
    />
  );
};
